<template>
  <section class="section-cart">
    <h2>Carrito de Compra</h2>
    <br />
    <div v-if="cartShop.cart.length === 0" class="section-cart__empty">
      <p>Tu carrito está vacío</p>
      <br />
      <br />
      <router-link to="/productos" class="button"
        >Agregar productos</router-link
      >
    </div>
    <section v-else class="section-cart__list">
      <div class="list-cart">
        <CardProductCart
          v-for="(product, id) in cartShop.cart"
          :key="id"
          :product="product"
        />
      </div>
      <div class="section_cart__info">
        <h3>Ingresa tu informacion</h3>
        <br />
        <form @submit.prevent="">
          Seleccionar tipo de documento:
          <select v-model="infoclient.type_document">
            <option value="0">Seleccione tipo de documeto</option>
            <option value="dni">DNI</option>
            <option value="ruc">RUC</option>
          </select>
          <input
            type="text"
            placeholder="Ingre el numero de documento"
            class="input-document"
            v-model="infoclient.number_document"
            v-if="infoclient.type_document != '0'"
          />
          <br />
          <input
            type="email"
            placeholder="Correo electronico"
            v-model="infoclient.email"
            required
          />
          <div class="section_cart__info__buttons">
            <button class="button-whatsapp" @click="() => sendWhatsApp()">
              Cotizar por WhatsApp
            </button>
            <button class="button-email" @click="() => sendEmail()">
              Cotizar por Correo
            </button>
          </div>
        </form>
      </div>
    </section>
  </section>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import CardProductCart from "./components/CardProductCart.vue";
import { useCartShoppingStore } from "@/store/cartshopping";

const cartShop = useCartShoppingStore();
const infoclient = ref({
  type_document: "",
  number_document: "",
  text_document: "",
  email: "",
});
const messageIncomplete = ref({
  number_document: "",
});

function validateFormInfo() {
  if (
    infoclient.value.type_document === "0" ||
    infoclient.value.number_document === "" ||
    infoclient.value.email === ""
  ) {
    return false;
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(infoclient.value.email)) {
    //console.log('Debe ingresar un correo electrónico válido');
    return false;
  }
  return true;
}

function sendWhatsApp() {
  if (!validateFormInfo()) {
    alert(
      "Por favor, completa todos los campos correctamente antes de enviar la cotizacion."
    );
    return;
  }

  let message = `Hola, me gustaría cotizar los siguientes productos:\n\n`;
  cartShop.cart.forEach((product) => {
    message += `- ${product.name_product} (${product.quantity} unidades)\n`;
  });
  message += `\nMis datos son:\nTipo de documento: ${infoclient.value.type_document}\nNúmero de documento: ${infoclient.value.number_document}\nCorreo electrónico: ${infoclient.value.email}`;

  const whatsappUrl = `https://api.whatsapp.com/send?phone=51998247832&text=${encodeURIComponent(
    message
  )}`;
  window.open(whatsappUrl, "_blank");
  //console.log('Enviar por WhatsApp', infoclient.value);
}

function sendEmail() {
  if (!validateFormInfo()) {
    alert(
      "Por favor, completa todos los campos correctamente antes de enviar la cotizacion."
    );
    return;
  }

  const subject = "Solicitud de Cotización";
  let body = `Hola, me gustaría cotizar los siguientes productos:\n\n`;
  cartShop.cart.forEach((product) => {
    body += `- ${product.name_product} (${product.quantity} unidades)\n`;
  });
  body += `\nMis datos son:\nTipo de documento: ${infoclient.value.type_document}\nNúmero de documento: ${infoclient.value.number_document}\nCorreo electrónico: ${infoclient.value.email}`;

  const mailtoUrl = `mailto:Johancanchary@gmail.com?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
  window.location.href = mailtoUrl;
}

async function getInfo() {
  if (infoclient.value.type_document === "dni") {
    // Lógica para obtener información del DNI
    // Aquí puedes hacer la llamada a la API para obtener la información del DNI
    try {
      const response = await fetch(
        `https://miapi.cloud/v1/dni/${infoclient.value.number_document}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxMjQsImV4cCI6MTc1MjQ0MjY5M30.pS1-aDsdostE5-GpyLs_WPhOSQ98-5_RJzQpVD-9b7o",
          },
        }
      );
      const data = await response.json();
      infoclient.value.text_document = `${data.datos.ape_paterno} ${data.datos.ape_materno} ${data.datos.nombres}`;
    } catch (error) {
      infoclient.value.text_document = "";
      //alert('No se pudo obtener la información del DNI. Por favor, verifica el número ingresado.');
      messageIncomplete.value.number_document =
        " No se pudo obtener el DNI; verifica el número.";
    }
  } else if (infoclient.value.type_document === "ruc") {
    // Lógica para obtener información del RUC
    // Aquí puedes hacer la llamada a la API para obtener la información del RUC
    try {
      const response = await fetch(
        `https://miapi.cloud/v1/ruc/det/${infoclient.value.number_document}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxMjQsImV4cCI6MTc1MjQ0MjY5M30.pS1-aDsdostE5-GpyLs_WPhOSQ98-5_RJzQpVD-9b7o",
          },
        }
      );
      const data = await response.json();
      infoclient.value.text_document = `${data.datos.razon_social}`;
    } catch (error) {
      infoclient.value.text_document = "";
      //alert('No se pudo obtener la información del RUC. Por favor, verifica el número ingresado.');
      messageIncomplete.value.number_document =
        "No se pudo obtener el RUC; verifica el número.";
    }
  }
}
</script>

<style lang="scss" scoped>
.section-cart {
  margin-top: 100px;
  padding-inline: 300px;
  h2 {
    font-size: 36px;
    text-align: start;
    font-weight: 600;
    line-height: normal;
  }
}
.section-cart__empty {
  p {
    color: $shade4;
    font-size: 18px;
    font-weight: 500;
    opacity: 0.8;
  }
  .button {
    margin-top: 20px;
    background-color: $whited;
    color: $tint1;
    font-weight: 500;
    border: 2px solid $tint1;
    padding: 10px 20px;
    border-radius: 5px;
    text-decoration: none;
    font-size: 16px;
  }
}
.section-cart__list {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  gap: 50px;
}
.list-cart {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.section_cart__info {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 40px 25px;
  flex: 0.5;
  text-align: start;
  h3 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  form {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    select {
      padding: 10px;
      border-radius: 5px;
      border: 1px solid #ccc;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .input-client {
      background-color: $tint4;
    }
    input {
      padding: 10px;
      border-radius: 5px;
      border: 1px solid #ccc;
      font-size: 16px;
    }
  }
  form .section_cart__info__buttons {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .button-whatsapp {
      background-color: #25d366;
      color: white;
      padding: 15px 20px;
      border-radius: 12px;
      border: none;
      cursor: pointer;
    }
    .button-email {
      background-color: #e7eff7;
      color: $shade2;
      padding: 15px 30px;
      border-radius: 12px;
      border: none;
      cursor: pointer;
    }
  }
}

@media (max-width: 1600px) {
  .section-cart {
    padding-inline: 100px;
  }
}
@media (max-width: 1080px) {
  .section-cart {
    padding-inline: 80px;
  }
}
@media (max-width: 950px) {
  .section-cart {
    .section-cart__list {
      flex-direction: column;
      gap: 50px;
      .list-cart {
        overflow-x: scroll;
        display: flex;
        flex-direction: row;
        gap: 5px;
      }
    }
  }
}
@media (max-width: 580px) {
  .section-cart {
    h2 {
      font-size: 28px;
    }
    padding-inline: 20px;
    .section-cart__list .section_cart__info {
      h3 {
        font-size: 20px;
      }
    }
  }
}
</style>
